import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./stores";
import i18n from "./lang/i18n";

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import VueMask from "v-mask";
Vue.use(VueMask);

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 1,
  newestOnTop: true,
  hideProgressBar: true,
  position: "top-center",
  timeout: 3000,
});

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import "bootstrap/dist/css/bootstrap.css";
import "animate.css/animate.min.css";

import { FirebaseMessaging } from "@/plugins/firebase";
import { HttpClient } from "./plugins/httpClient";
import { sleep } from "@/plugins/helpers";
import axios from "axios";
import moment from "moment";
import { GoogleSpreadsheet } from "google-spreadsheet";

Vue.mixin({
  computed: {
    $articles() {
      return this.$store.getters["Article/articles"];
    },
    $plenaryArticles() {
      var articles = this.$store.getters["Article/articles"] || [];
      return articles.filter(
        (a) => !a.Session || a.Session.includes("Plenary")
      );
    },
    $parallelArticles() {
      var articles = this.$store.getters["Article/articles"] || [];
      return articles.filter(
        (a) => a.Session && !a.Session.includes("Plenary")
      );
    },
    $dates() {
      return ["27", "28", "29"];
    },
    $date() {
      return this.$store.getters["Article/date"] || [];
    },
    $keySearch() {
      return this.$store.getters["Article/keySearch"] || [];
    },
    $room() {
      return this.$store.getters["Article/room"] || [];
    },
    $onGogoingArticles() {
      var articles = this.$store.getters["Article/articles"] || [];
      var now = moment();
      return articles.filter((a) => {
        var { Start, End, Date } = a;
        if (!Start || !End) return false;
        var start = moment(`${Date}/12/2022`, "DD/MM/YYYY")
          .set("hour", parseInt(Start.split(":")[0]))
          .set("minute", parseInt(Start.split(":")[1]))
          .set("second", 0);
        var end = moment(`${Date}/12/2022`, "DD/MM/YYYY")
          .set("hour", parseInt(End.split(":")[0]))
          .set("minute", parseInt(End.split(":")[1]))
          .set("second", 0);
        return start.isBefore(now) && now.isBefore(end);
      });
    },
    $sessions() {
      return this.$store.getters["Article/sessions"];
    },
    $rooms() {
      return this.$store.getters["Article/rooms"];
    },
    isNative() {
      return true;
    },
    userID() {
      return this.$store.getters["Authen/getUser"].userID;
    },
    isLargeWebVersion() {
      return this.$vuetify.breakpoint.width >= 1280;
    },
    isWebVersion() {
      return this.$vuetify.breakpoint.width >= 820;
    },
    isMobileVersion() {
      return this.$vuetify.breakpoint.width < 820;
    },
    deviceRatio() {
      var result = Math.floor(
        (this.$vuetify.breakpoint.height / this.$vuetify.breakpoint.width) * 100
      );
      if (this.isMobileVersion) {
        result -= 25;
      } else {
        result += 5;
      }
      return result;
    },
    $httpClient() {
      return new HttpClient(process.env.VUE_APP_API_URL);
    },
    $fcm() {
      return FirebaseMessaging;
    },
    statusCode() {
      return {
        Danger: 0,
        Info: 1,
        Warning: 2,
        Success: 3,
      };
    },
    btnHeight() {
      if (this.isWebVersion) return 90;
      return 60;
    },
    headerImgStyle() {
      // var hour = moment().hour();
      var backgroundImage = `url('/background.jpeg')`;
      // var backgroundImage = `url('/img/land-${
      //   hour < 6 ? 5 : hour < 12 ? 6 : hour < 18 ? 2 : 5
      // }.jpg')`;
      if (this.isWebVersion) {
        return {
          backgroundImage,
          backgroundPosition: "right top",
        };
      }
      return {
        backgroundImage,
        backgroundPosition: "center",
      };
    },
  },
  mounted() {
    // if back button is pressed
    window.onpopstate = () => {
      if (this.$store.getters["Mobile/diaglogState"]) {
        this.$router.push(this.$route.name);
        setTimeout(() => {
          this.closeDiaglogIfMobile();
        }, 50);
      }
    };
  },
  methods: {
    sleep,
    async loadArticles() {
      const doc = new GoogleSpreadsheet(
        "1ygbbxNOLaBMma6f9JbKCQwdlLYbmeBhlca_2YDNIcCU"
      );
      doc.useApiKey(process.env.VUE_APP_GCP_API_KEY);
      await doc.loadInfo();
      var articles = [];
      for (var i = 0; i < 3; i++) {
        var sheet = doc.sheetsByIndex[i];
        var rows = await sheet.getRows();
        articles = articles.concat(
          rows.map((r) => {
            var {
              ID,
              Start,
              End,
              Title,
              Room,
              Author,
              Session,
              AbstractUrl,
              Date,
            } = r;
            return {
              ID,
              Start,
              End,
              Title,
              Room,
              Author,
              Session,
              AbstractUrl,
              Date,
              Overdue: moment().isAfter(
                moment(`${r.Date}/12/2022 ${r.End}:00`, "DD/MM/YYYY HH:mm:ss")
              ),
              IsRunning:
                moment().isBefore(
                  moment(`${r.Date}/12/2022 ${r.End}:00`, "DD/MM/YYYY HH:mm:ss")
                ) &&
                moment().isAfter(
                  moment(
                    `${r.Date}/12/2022 ${r.Start}:00`,
                    "DD/MM/YYYY HH:mm:ss"
                  )
                ),
            };
          })
        );
      }
      console.log(articles);
      this.$store.commit("Article/SET_ARTICLES", articles);
      await this.loadSessions(articles);
      await this.loadRooms(articles);
    },
    async loadSessions(articles = []) {
      var sessions = articles.map((a) => a.Session);
      sessions = sessions.filter((item, i, ar) => ar.indexOf(item) === i);
      sessions.unshift({ text: "All Sessions", value: "" });
      this.$store.commit("Article/SET_SESSIONS", sessions);
    },
    async loadRooms(articles = []) {
      var rooms = articles.map((a) => a.Room);
      rooms = rooms.filter((item, i, ar) => ar.indexOf(item) === i);
      rooms.unshift({ text: "All Rooms", value: "" });
      this.$store.commit("Article/SET_ROOMS", rooms);
    },
    capitalizeFirstLetter(string) {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatTime(time) {
      if (!time) return moment().format("L, h:mm:ss a");
      return moment(time).format("L, h:mm:ss a");
    },
    randomItem(items) {
      return items[Math.floor(Math.random() * items.length)];
    },
    sfxClick() {
      this.$store.commit("sfx/click");
    },
    sfxSkip() {
      this.$store.commit("sfx/skip");
    },
    callPhone(phone) {
      if (phone) window.open(`tel:${phone}`);
    },
    openDiaglogIfMobile(title) {
      if (this.isMobileVersion) {
        this.$store.commit("Mobile/SET_DIAGLOG_STATE", true);
        this.$store.commit("Mobile/SET_DIAGLOG_TITLE", title);
      }
    },
    closeDiaglogIfMobile() {
      if (this.isMobileVersion) {
        this.$store.commit("Mobile/SET_DIAGLOG_STATE", false);
        this.$store.commit("Mobile/SET_DIAGLOG_TITLE", "");
      }
    },
    openBrowserNewTab(url) {
      window.open(url, "_blank");
    },
    showError: function (message) {
      console.error(message);
    },
    showErrorPopup(message) {
      this.$toast.error(message);
    },
    showSuccess: function (message) {
      this.$toast.success(message);
    },
    showInfo: function (message) {
      this.$toast.info(message);
    },
    showWarning: function (message) {
      this.$toast.warning(message);
    },
    async $dbGet(database, ref) {
      return new Promise((resolve) => {
        database
          .ref()
          .child(ref)
          .get()
          .then((snapshot) => {
            if (snapshot.exists()) {
              return resolve(snapshot.val());
            } else {
              console.log("No data available");
              return resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            return resolve(false);
          });
      });
    },
    async translateTo(text = "", lang = "en") {
      if (!text) return {};
      var API_KEY = process.env.VUE_APP_GCP_API_KEY;
      var { data } = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?q=${text}&target=${lang}&key=${API_KEY}`
      );
      return data.data.translations[0].translatedText.split("&#39").join("'");
    },
    async sendDataToSandrasoftIframe(
      eventName = "onAnalyticsReceived",
      data = {}
    ) {
      if (!window || !window.parent || !window.parent.postMessage) return;
      var message = {
        appName: "Inner Me",
        eventName,
        data,
      };
      try {
        window.parent.postMessage(JSON.stringify(message), "*");
      } catch (err) {
        console.log("sendDataToSandrasoftIframe Error", err.message);
      }
    },
  },
});

Vue.config.productionTip = false;
Vue.config.productionSourceMap = false;

export const VueInstance = new Vue({
  i18n,
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
